import { useContext, useState, useEffect } from "react";
import { DiscoveryContext } from "../discovery-context";
import ReTableView from "../../Dashboard/common/ReTableView"
import { transformSourcesResponse, transformOldSourcesResponse } from "../../../utils/helpers"
import { downloadExcelV2, prepareSourceDataForExcel } from "../../../utils/monitoring-helpers";
import { Button } from "@mui/material";
import classes from "./Sources.module.css";
import { ENTITY_LABELS } from "../../../utils/labelMapping";


export default function Sources() {
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryType = discoveryCtx.type || "brand";
  const sources = discoveryCtx?.sources ?? [];
  const category = discoveryCtx.category;
  const llm = discoveryCtx.llm;
  const market = discoveryCtx.market;
  const sourcesData = {};
  const showOldSourcesRecord = discoveryCtx.state.sourceValidationStatus === "PENDING";

  const dropdownOptions = sources && typeof sources === 'object'
    ? Object.keys(sources).map(key => ({ value: key, label: key  }))
    : [];
  const [selectedBrandSources, setSelectedBrandSources] = useState(
    []
  );
  useEffect(() => {
    setSelectedBrandSources(dropdownOptions.map((o) => o.label));
  }, [JSON.stringify(dropdownOptions)]);
  let data;
  const selectedInput = {
    brand: discoveryCtx.entity,
    category,
    // geography: market,
    llm,
    market,
    // persona: "General Persona",
    product: discoveryCtx.type == "product" ? true : false,
  }
  const labelMapping = {
    LLM: "llm",
  }
  const sourceFilter = {
    value: "LLM",
    label: "Compare by LLM"
  }

  if (!sourcesData[llm]) sourcesData[llm] = {};
  if (!sourcesData[llm][category]) sourcesData[llm][category] = {};
  if (!sourcesData[llm][category][market]) sourcesData[llm][category][market] = {};
  sourcesData[llm][category][market] = selectedBrandSources.reduce((acc, key) => {
    if (sources[key]) {
      acc.push(...sources[key]);
    }
    return acc;
  }, []);

  if (showOldSourcesRecord) {
    data = transformOldSourcesResponse(sourcesData, [discoveryCtx.llm], category, market);
  } else {
    data = transformSourcesResponse(sourcesData, [discoveryCtx.llm], category, market);
  }
  const isSourceValidating =
    discoveryCtx.state?.sourceValidationStatus === "RUNNING" &&
    ["COMPLETED", "RETRY"].includes(discoveryCtx.state?.transactionStatus);
  return (
    <>
      <Button
        onClick={() => {
          const preparedData = prepareSourceDataForExcel(data, selectedInput, labelMapping, sourceFilter);
          downloadExcelV2(preparedData, labelMapping[sourceFilter?.value]);
        }}
      >
        Export
      </Button>
      {isSourceValidating &&
        <div className={classes.validationMessage}>
          <div>
            <span style={{ fontSize: "18px", marginRight: "8px" }}>⏳</span>
            Source validation is still in progress
          </div>
        </div>
      }
      <ReTableView
        type={`${discoveryType === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product}`}
        data={data}
        isValidated={!showOldSourcesRecord}
        isOverview={true}
        dropdownOptions={dropdownOptions}
        selectedDropdownValues={selectedBrandSources}
        onDropdownChange={(newVal) =>
          setSelectedBrandSources(Array.isArray(newVal) ? newVal : (newVal?.target ? newVal.target.value : selectedBrandSources))
        }
      />
    </>
  );
}
